import { useProtocolGet } from '../../APIs/Hooks/ProtocolHooks'
import { useMemo } from 'react'
import { useStudyContext } from '../../Contexts/Modules/StudyModule/SelectedStudyModule'
import { tsStudyAttribute } from '../../Typescript/StuartPy/StudyAttribute'

export function useGetProtocolName(protocol_id: string | null) {
  const { data: protocolList } = useProtocolGet('')
  return useMemo(() => {
    if (protocolList && protocol_id) {
      const protocol = protocolList.filter(
        (f: { ProtocolID: number }) => f.ProtocolID === parseInt(protocol_id!),
      )[0]
      return protocol.EthicsNumber
    } else {
      return ''
    }
  }, [protocolList, protocol_id])
}

export function useStudyAttr() {
  const { studyQuery } = useStudyContext()
  return useMemo(() => {
    if (studyQuery.data?.phases) {
      let allAttributes: tsStudyAttribute[] = []
      studyQuery.data?.phases.forEach(
        (phase) => (allAttributes = allAttributes.concat(phase.attributes)),
      )
      return allAttributes
    } else {
      return []
    }
  }, [studyQuery.data])
}
